const newActionHeader = {
  label: 'CREAR UNA PUBLICACIÓN'
};

export default newActionHeader;
